import { LastLoginInfoMutations } from './partials/LastLoginInfo'

export const AuthenticationMutations = {
  ...LastLoginInfoMutations,

  setMultifactorAuthenticationSettings: (state, payload) => {
    state.multifactorAuthenticationSettings = payload
  },

}
